import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Text from '../../Text/Text';

const useStyles = makeStyles((theme) => ({
  bluetitle: {
    fontWeight:'bold',
    marginTop:'10px',
    fontSize:12,
  },
  paragraph:{
      fontSize:10,
  }
}));
const ApealCitationFormData = () => {
    const classes = useStyles();

    return (
        <div>
           <Text
                align={'left'}
                className={classes.bluetitle}
                color={'primary'}
            >
                Driver Name :
            </Text>
            <Text
                align={'left'}
                className={classes.paragraph}
                color={'primary'}
            >
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.
                
            </Text>
            <Text
                align={'left'}
                className={classes.bluetitle}
                color={'primary'}
            >
                Email Address :
            </Text>
            <Text
                align={'left'}
                className={classes.paragraph}
                color={'primary'}
            >
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. 
            </Text>
            <Text
                align={'left'}
                className={classes.bluetitle}
                color={'primary'}
            >
                Appeal Reason :
            </Text>
            <Text
                align={'left'}
                className={classes.paragraph}
                color={'primary'}
            >
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.
            </Text>
            <Text
                align={'left'}
                className={classes.bluetitle}
                color={'primary'}
            >
                Appeal Process :
            </Text>
            <Text
                align={'left'}
                className={classes.paragraph}
                color={'primary'}
            >
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. 
            </Text> 
        </div>
    )
}

export default ApealCitationFormData
